export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/phone-call-white.8d2700db.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};